"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useQuery } from "@tanstack/react-query";
function fetchFeatureFlags() {
  return __async(this, null, function* () {
    const response = yield fetch("/api/v4/feature_flags", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      credentials: "same-origin"
    });
    if (!response.ok) {
      throw new Error("Failed to fetch feature flags");
    }
    const data = yield response.json();
    return data.flags;
  });
}
const FEATURE_FLAGS_QUERY_KEY = ["feature-flags"];
export function useFeatureFlags() {
  return useQuery({
    queryKey: FEATURE_FLAGS_QUERY_KEY,
    queryFn: fetchFeatureFlags,
    staleTime: 10 * 60 * 1e3,
    // 10 minutes - feature flags don't change often
    cacheTime: 30 * 60 * 1e3,
    // 30 minutes cache
    refetchOnWindowFocus: true,
    // Refetch when user returns to tab (most likely time for changes)
    refetchOnMount: false,
    // Don't refetch on mount if we have cached data
    retry: 2
  });
}
export function useFeatureFlag(flag) {
  var _a;
  const { data: flags, isLoading, error } = useFeatureFlags();
  if (isLoading) return false;
  if (error) return false;
  return (_a = flags == null ? void 0 : flags[flag]) != null ? _a : false;
}
